enum FadeDirections {
  top = "top",
  left = "left",
  right = "right",
}

export default FadeDirections
